module.exports = __webpack_public_path__ + "static/media/regal-rush-vertical-blue-bg-dark-gold-300x300.e1c3798b.png";